import Button from "@components/common/Button";
import Input from "@components/common/Input";
import SelectHasMoreMultipleInputs from "@components/common/SelectHasMoreMultipleInputs";
import SelectInput from "@components/common/SelectInput";
import SelectInputClient from "@components/common/SelectInputClient";
import SelectMultipleInputs from "@components/common/SelectMultipleInputs";
import EmailIcon from "@components/icons/EmailIcon";
import FloppyDiskIcon from "@components/icons/FloppyDiskIcon";
import ModalAlert from "@components/Modals/ModalAlert";
import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { useFeatureValue } from "@growthbook/growthbook-react";
import { fetchAllBusinessUnits } from "@services/accountMangement/businessUnitsService";
import { fetchClients } from "@services/accountMangement/clientsService";
import { fetchDistributersData } from "@services/accountMangement/distributorsService";
import { fetchResellersData } from "@services/accountMangement/resellersService";
import {
	createUser,
	fetchUserById,
	resendRegisterEmail,
	updateUser,
} from "@services/accountMangement/userService";
import { fetchAllRolesData } from "@services/roleService";
import { fetchVessels } from "@services/vesselService";
import { setAllBusinessUnitsList } from "@store/modules/accountManagement/businessUnitsSlice";
import {
	setAddUser,
	setLoadingUsers,
	setSelectedUser,
} from "@store/modules/accountManagement/usersSlice";
import { setLoadingRoles, setRolesData } from "@store/modules/roleSlice";
import {
	IS_ACTIVATION_ROLE,
	IS_ADMIN_ROLE,
	IS_CUSTOMER_READONLY_ROLE,
	IS_CUSTOMER_ROLE,
	IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE,
	IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE,
	IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE,
	IS_DISTRIBUTOR_READONLY_ROLE,
	IS_DISTRIBUTOR_ROLE,
	IS_RESELLER_CUSTOMER_READONLY_ROLE,
	IS_RESELLER_CUSTOMER_ROLE,
	IS_RESELLER_ROLE,
	IS_SALES_ROLE,
	IS_TECHNICAL_PARTNER_ROLE,
} from "@utils/user_roles";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FLAGS } from "../../../config/growthbook/flags.js";
import FormForAdistaT from "./FormForAdistaT";
import FormForCustormer from "./FormForCustormer";
import FormForDistributor from "./FormForDistributor";
import RoleListItem from "./RoleListItem";

const FormUsers = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { id } = useParams();
	const controller = new AbortController();

	const [isSubmitting, setIsSubmitting] = useState(false);
	const statusData = [
		{ id: "0", status: "Disabled" },
		{ id: "1", status: "Enabled" },
	];
	const [statusId, setStatusId] = useState("");
	const [lastName, setLastName] = useState("");
	const [firstName, setFirstName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [userNotification, setUserNotification] = useState(false);
	const [vesselAccess, setVesselAccess] = useState(false);
	const [clientAccess, setClientAccess] = useState(false);

	const [name, setName] = useState("");

	const [selectedUnitId, setSelectedUnitId] = useState([]);

	const [uploadedFile, setUploadedFile] = useState(null);
	const [selectedRoleId, setSelectedRoleId] = useState(null);
	const [selectedParentId, setSelectedParentId] = useState(null);
	const [selectedRoleName, setSelectedRoleName] = useState(null);

	const [clientId, setClientId] = useState("");
	const [filteredClients, setFilteredClients] = useState([]);
	const [vesselName, setVesselName] = useState([]);
	const [selectedVessels, setSelectedVessels] = useState([]);
	const [selectedClients, setSelectedClients] = useState([]);

	const [filteredVessels, setFilteredVessels] = useState([]);
	const [loadingClientsBu, setLoadingClientsBu] = useState(false);
	const [loadingDistBu, setLoadingDistBu] = useState(false);
	const [loadingClientDist, setLoadingClientDist] = useState(false);
	const [loadingResellerDist, setLoadingResellerDist] = useState(false);

	const [distributerId, setDistributerId] = useState("");
	const [distributerName, setDistributerName] = useState("");
	const [filteredDistributers, setFilteredDistributers] = useState([]);
	const [clientsByDistribuer, setClientsByDistribuer] = useState([]);

	const [resellerId, setResellerId] = useState("");
	const [filteredResellers, setFilteredResellers] = useState([]);

	const [loadingClientsReseller, setLoadingClientsReseller] = useState(false);
	const [filteredClientsReseller, setFilteredClientsReseller] = useState([]);

	const [pageVessel, setPageVessel] = useState(1);
	const [loader, setLoader] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [searchTerm, setSearchTerm] = useState([]);

	const [pageClient, setPageClient] = useState(1);
	const [searchTermClient, setSearchTermClient] = useState("");
	const [loaderClient, setLoaderClient] = useState(false);
	const [hasMoreClient, setHasMoreClient] = useState(true);

	const [loadingDetails, setLoadingDetails] = useState(false);

	const [selectedClientName, setSelectedClientName] = useState("");
	const [enableActivation, setEnableActivation] = useState(false);

	const isMobile = useIsMobile();

	const allBusinessList = useSelector(
		(state) => state.modules.accountManagement.businessUnits.list || [],
	);

	const businessUnitsFetched = useSelector(
		(state) => state.modules.accountManagement.businessUnits.businessUnitsFetched,
	);
	const { token, permissions, distributor, clients, business_units } = useSelector(
		(state) => state.auth.user,
	);

	const accountManagement = permissions.find(
		(resource) => resource.resource_name === "account_management",
	);
	const users = accountManagement?.sub_resources?.find(
		(subResource) => subResource.sub_resource_name === "account_management_users",
	);
	const authorizedPermissions = users?.permissions?.filter(
		(permission) => permission.authorized === true,
	);
	const canEditUsers = authorizedPermissions?.some(
		(permission) => permission.name === "update users",
	);

	const currentUserRole = useSelector((state) => state.auth.user.role);
	const currentRequestId = useRef(0);

	const isDistributor = [
		IS_DISTRIBUTOR_ROLE,
		IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE,
		IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE,
	].includes(currentUserRole?.id);

	const isCustomer = [IS_CUSTOMER_ROLE, IS_CUSTOMER_READONLY_ROLE].includes(currentUserRole?.id);

	// const rolesList = useSelector(
	//   (state) => state.modules.accountManagement.roles.data || []
	// );

	const transformedRolesList = useSelector(
		(state) => state.modules.accountManagement.roles.data || [],
	);
	const rolesList = transformedRolesList;
	// ? {
	//     ...transformedRolesList, // Keep other properties intact
	//     data:
	//       transformedRolesList.data?.map((role) => ({
	//         ...role,
	//         name:
	//           role.name === "distributor"
	//             ? "Customer Admin"
	//             : role.name === "distributor_readonly"
	//             ? "Customer"
	//             : role.name,
	//       })) || [],
	//   }
	// : transformedRolesList;

	const loading = useSelector((state) => state.modules.accountManagement.roles.loading);
	const isloading = useSelector((state) => state.modules.accountManagement.userState.loading);

	const userDetails = useSelector(
		(state) => state.modules.accountManagement.userState.selectedUser,
	);

	const businessUnitVisible = useFeatureValue(FLAGS.shared.distributors.businessUnitVisible, true);
	const resellerFetchEnabled = useFeatureValue(FLAGS.shared.clients.resellerFetchEnabled, true);
	const typeFilterEnabled = useFeatureValue(
		FLAGS.shared.distributorsFilter.typeFilterEnabled,
		true,
	);
	const distributorPrefetchEnabled = useFeatureValue(
		FLAGS.users.form.distributorPrefetchEnabled,
		false,
	);
	const adistaLayoutEnabled = useFeatureValue(FLAGS.users.form.adistaLayoutEnabled, false);
	const companyIdInPayloadEnabled = useFeatureValue(
		FLAGS.users.form.companyIdInPayloadEnabled,
		true,
	);
	const distributorFieldValidationEnabled = useFeatureValue(
		FLAGS.users.form.distributorFieldValidationEnabled,
		true,
	);
	const adistaDisplayEnabled = useFeatureValue(FLAGS.users.roles.adistaDisplayEnabled, false);

	const resellerCompanyIdInPayloadEnabled = useFeatureValue(
		FLAGS.users.form.resellerCompanyIdInPayloadEnabled,
		true,
	);
	const distributorFieldVisible = useFeatureValue(FLAGS.users.form.distributorFieldVisible, true);

	const lastLogin = userDetails?.data?.last_login;

	const [errors, setErrors] = useState({
		email: "",
		password: "",
		lastName: "",
		firstName: "",
		statusId: "",
		userNotification: "",
		selectedUnitId: "",
		clientId: "",
		vesselName: "",
		uploadedFile: "",
		distributerId: "",
		enable_notification: "",
		enable_activation: "",
		resellerId: "",
	});
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);
	const [successMessage, setSuccessMessage] = useState(false);
	const [showSuccessModal, setShowSuccessModal] = useState(false);

	const fetchedRoles = useRef(false);
	const fetchedUserDetails = useRef(false);
	const handleReloadUser = async () => {
		if (token && id) {
			const data = await fetchUserById(id, token, dispatch, navigate);
			dispatch(setSelectedUser({ data }));
		}
	};

	const debouncedRolesFetch = useMemo(
		() =>
			debounce(async () => {
				if (fetchedRoles.current) return;
				fetchedRoles.current = true;

				if (token) {
					dispatch(setLoadingRoles(true));
					try {
						const data = await fetchAllRolesData(token, dispatch, navigate);
						dispatch(setRolesData({ data }));
					} catch (error) {
						console.error("Failed to fetch roles:", error);
					} finally {
						dispatch(setLoadingRoles(false));
					}
				}
			}, 30),
		[token, dispatch, navigate],
	);

	const debouncedUserDetailsFetch = useMemo(
		() =>
			debounce(async () => {
				handleReloadUser();

				if (token && id) {
					setLoadingDetails(true);
					try {
						const data = await fetchUserById(id, token, dispatch, navigate);
						dispatch(setSelectedUser({ data }));
					} catch (error) {
						console.error("Failed to fetch user:", error);
					} finally {
						setLoadingDetails(false);
					}
				}
			}, 30),
		[token, id, dispatch, navigate],
	);

	const debouncedFetchDistributors = useMemo(
		() =>
			debounce(async () => {
				try {
					const searchTerms = {
						businessUnits: selectedUnitId ? [selectedUnitId] : null, // Ensure correct data format
					};

					const data = await fetchDistributersData(
						token,
						dispatch,
						navigate,
						1,
						10,
						0,
						allBusinessList.length === 1 ? allBusinessList[0].id : searchTerms,
					);
					setFilteredDistributers(data.data || []); // Ensure state is always updated
				} catch (error) {
					console.error("Failed to fetch distributors:", error);
				}
			}, 30),
		[token, id, dispatch, navigate],
	);

	const debouncedFetchClientsForDistributor = useMemo(
		(sig) =>
			debounce(async () => {
				setLoadingClientDist(true);
				setLoaderClient(true);

				try {
					const data = await fetchClients(
						token,
						dispatch,
						navigate,
						pageClient,
						10,
						{
							filter: searchTermClient,
						},
						1,
						sig,
					);

					const totalPage = Math.ceil(data.totalItems / data.perPage);

					const updatedOptions =
						pageClient === 1 ? data.data : [...clientsByDistribuer, ...data.data];
					setClientsByDistribuer(updatedOptions || []);
					setHasMoreClient(totalPage > pageClient);
				} catch (error) {
					console.error("Failed to fetch client:", error);
				} finally {
					setLoadingClientDist(false);
					setLoaderClient(false);
				}
			}, 30),
		[token, dispatch, navigate],
	);

	useEffect(() => {
		const fetchBusinessUnits = async () => {
			if (token && !businessUnitsFetched) {
				try {
					const data = await fetchAllBusinessUnits(token, dispatch, navigate, 0);
					dispatch(setAllBusinessUnitsList({ data }));
				} catch (error) {
					console.error("Failed to fetch business units:", error);
				}
			}
		};

		const executeFetches = async () => {
			await fetchBusinessUnits();
			await debouncedRolesFetch();
			await debouncedUserDetailsFetch();

			distributorPrefetchEnabled && (await debouncedFetchDistributors());

			distributorPrefetchEnabled && (await debouncedFetchClientsForDistributor());
		};

		executeFetches();

		return () => {
			debouncedRolesFetch.cancel();
			debouncedUserDetailsFetch.cancel();
			debouncedFetchDistributors.cancel();
			debouncedFetchClientsForDistributor.cancel();
		};
	}, [
		token,
		id,
		dispatch,
		navigate,
		businessUnitsFetched,
		debouncedRolesFetch,
		debouncedUserDetailsFetch,
		debouncedFetchDistributors,
		debouncedFetchClientsForDistributor,
	]);

	const vesselData = filteredVessels?.length;
	const clientData = filteredClients?.length;

	useEffect(() => {
		if (adistaLayoutEnabled) {
			setSelectedUnitId([business_units?.[0]?.id]);
			setName(business_units?.[0]?.name);
			selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedRoleId === IS_DISTRIBUTOR_READONLY_ROLE
				? setDistributerId(distributor?.id)
				: null;
			selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedRoleId === IS_DISTRIBUTOR_READONLY_ROLE
				? setDistributerName(distributor?.name)
				: null;
			fetchClientsForDistributor(null, controller.signal, pageClient, searchTermClient);
		}
	}, [selectedRoleId, searchTermClient, pageClient]);

	useEffect(() => {
		const initializeData = async () => {
			if (id && userDetails?.data) {
				const userToEdit = userDetails?.data || {};

				setSelectedRoleName(userToEdit?.role?.name || null);
				setSelectedRoleId(userToEdit?.role?.id || null);
				setSelectedParentId(userToEdit?.role?.parent_id || null);

				setStatusId(userToEdit?.state ? "1" : "0");
				setLastName(userToEdit?.last_name);
				setFirstName(userToEdit?.first_name);
				setEmail(userToEdit?.email);
				// setPassword("Iec@2024");
				setUserNotification(userToEdit?.enable_notification || 0);
				setEnableActivation(userToEdit?.enable_activation === 1);

				if (
					userToEdit?.role?.id === IS_CUSTOMER_ROLE ||
					(userToEdit?.role?.parent_id === IS_CUSTOMER_ROLE &&
						userToEdit?.role?.id !== IS_TECHNICAL_PARTNER_ROLE)
				) {
					setSelectedUnitId(userToEdit?.business_units?.map((bu) => bu?.id));

					if (userToEdit?.business_units?.[0]?.id) {
						!isCustomer && (await fetchClientsForBu(selectedUnitId));

						setClientId(userToEdit?.clients[0]?.id);
					}

					if (userToEdit?.clients?.[0]?.id) {
						setSearchTermClient(userToEdit?.clients[0]?.name);

						await fetchVesselsByClients(userToEdit?.clients?.[0]?.id);

						const allVessels = userToEdit?.all_vessels;

						if (allVessels === true || userToEdit.vessels?.length === 0) {
							setVesselAccess(false);
							setVesselName("");
						} else {
							setVesselAccess(true);
							setVesselName(userToEdit.vessels?.map((vessel) => vessel?.id));
							setSelectedVessels(userToEdit.vessels || []);
						}
					}
				}

				// Role handling: Check if the role is 'technical partner as customer'
				if (
					userToEdit?.role?.parent_id === IS_CUSTOMER_ROLE &&
					userToEdit?.role?.id === IS_TECHNICAL_PARTNER_ROLE
				) {
					setSelectedUnitId(userToEdit?.business_units?.map((bu) => bu?.id));
					await fetchClientsForBu(userToEdit?.business_units?.map((bu) => bu?.id));

					setClientId(userToEdit.clients?.map((cl) => cl?.id));
				}

				// Role handling: Check if the role is 'distributor'
				if (
					userToEdit?.role?.id === IS_DISTRIBUTOR_ROLE ||
					userToEdit?.role?.parent_id === IS_DISTRIBUTOR_ROLE
				) {
					setSelectedUnitId(userToEdit?.business_units?.map((bu) => bu?.id));

					!isDistributor && (await fetchDistributersForBu([userToEdit?.business_units[0]?.id]));
					setDistributerId(userToEdit?.company?.id);

					// if (userToEdit?.company?.id) {
					//   await fetchClientsForDistributor(userToEdit?.company?.id);
					// }

					if (
						(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
							selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE ||
							selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE) &&
						userToEdit?.role?.id !== IS_DISTRIBUTOR_ROLE
					) {
						await fetchClientsForDistributor(userToEdit?.company?.id);

						setClientId(userToEdit?.clients[0]?.id);

						if (userToEdit?.clients?.[0]?.id) {
							await fetchVesselsByClients(userToEdit?.clients?.[0]?.id);

							const allVessels = userToEdit?.all_vessels;

							if (allVessels === true || userToEdit.vessels?.length === 0) {
								setVesselAccess(false);
								setVesselName("");
							} else {
								setVesselAccess(true);
								setVesselName(userToEdit.vessels?.map((vessel) => vessel?.id));
								setSelectedVessels(userToEdit.vessels || []);
							}
						}
					}
				}

				if (
					userToEdit?.role?.id === IS_SALES_ROLE ||
					userToEdit?.role?.parent_id === IS_SALES_ROLE
				) {
					setSelectedUnitId(userToEdit?.business_units?.map((bu) => bu?.id));
					await fetchClientsForBu(userToEdit?.business_units?.map((bu) => bu?.id));

					const allClients = userToEdit?.all_clients;
					if (allClients === true || userToEdit?.clients.length === 0) {
						setClientAccess(false);
						setClientId("");
					} else {
						setClientAccess(true);
						setClientId(userToEdit.clients?.map((cl) => cl?.id));
					}
				}

				if (
					userToEdit?.role?.id === IS_RESELLER_ROLE ||
					userToEdit?.role?.parent_id === IS_RESELLER_ROLE
				) {
					setSelectedUnitId(userToEdit?.business_units?.map((bu) => bu?.id));
					await fetchDistributersForBu([userToEdit?.business_units[0]?.id]);
					setDistributerId(userToEdit?.company?.id);
					setDistributerName(userToEdit?.company?.name);
					if (userToEdit?.company?.id) {
						await fetchResellersForDist(userToEdit?.company?.id);
					}

					if (Array.isArray(userToEdit.reseller)) {
						setResellerId(userToEdit?.reseller.map((reseller) => reseller.id));
					} else if (userToEdit.reseller) {
						setResellerId(userToEdit?.reseller?.id);
					} else {
						setResellerId("");
					}
					if (
						(selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
							selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE) &&
						userToEdit?.role?.id !== IS_RESELLER_ROLE
					) {
						await fetchClientsForReseller(userToEdit?.reseller?.id);

						setClientId(userToEdit?.clients[0]?.id);

						if (userToEdit?.clients?.[0]?.id) {
							await fetchVesselsByClients(userToEdit?.clients?.[0]?.id);

							const allVessels = userToEdit?.all_vessels;

							if (allVessels === true || userToEdit.vessels?.length === 0) {
								setVesselAccess(false);
								setVesselName("");
							} else {
								setVesselAccess(true);
								setVesselName(userToEdit.vessels?.map((vessel) => vessel?.id));
								setSelectedVessels(userToEdit.vessels || []);
							}
						}
					}
				}
			}
		};

		initializeData();
	}, [token, id, dispatch, navigate, userDetails]);

	const handleNavigateUsersList = () => {
		navigate("../account_management/users");
	};

	const handleStatusChange = (id, selectedStatus) => {
		setStatusId(selectedStatus);
	};

	const handleClearInput = (inputId) => {
		if (inputId === "status") {
			setStatusId("");
		}
		if (inputId === "firstName") {
			setFirstName("");
		}
		if (inputId === "lastName") {
			setLastName("");
		}
		if (inputId === "email") {
			setEmail("");
		}
		if (inputId === "password") {
			setPassword("");
		}
		if (inputId === "unitName") {
			setSelectedUnitId("");
		}
		if (inputId === "ipAddress") {
			setIpAddress("");
		}
		if (inputId === "uploadedFile") {
			setUploadedFile("");
		}
		if (inputId === "clientId") {
			setClientId("");
		}
		if (inputId === "vesselName") {
			setVesselName("");
		}
		if (inputId === "distributerId") {
			setDistributerId("");
		}
		if (inputId === "distributerName") {
			setDistributerName("");
		}
		if (inputId === "clientAccess") {
			setClientAccess("");
		}
		if (inputId === "vesselAccess") {
			setVesselAccess("");
		}
		if (inputId === "resellerId") {
			setResellerId("");
		}
	};
	const handleBusinessUnitChange = (id, selectedId, selectedName) => {
		if (selectedId.length === 0) {
			setSelectedUnitId("");
			setName("");
			setDistributerId("");
			handleClearInput("filteredClients");
			handleClearInput("clientAccess");
			handleClearInput("vesselName");
			handleClearInput("vesselAccess");
			handleClearInput("filteredDistributers");
			setResellerId("");

			setSearchTermClient(null);

			setFilteredClients([]);
			setFilteredDistributers([]);
			setFilteredVessels([]);
		} else {
			setSelectedUnitId(selectedId);
			setName(selectedName);
			handleClearInput("filteredClients");
			handleClearInput("distributerId");
			handleClearInput("distributerName");
			setClientAccess(false);
			setVesselAccess(false);
			setClientsByDistribuer("");
			setClientId("");
			fetchClientsForBu(selectedId);
			setFilteredClients([]);
			setSearchTermClient("");
			setPageClient(1);

			fetchDistributersForBu(selectedId);
		}

		setErrors((prevErrors) => ({
			...prevErrors,
			selectedUnitId: "",
		}));
	};

	const fetchDistributersForBu = async (unitId) => {
		if (
			token &&
			(selectedRoleId === IS_DISTRIBUTOR_ROLE ||
				selectedParentId === IS_DISTRIBUTOR_ROLE ||
				selectedRoleId === IS_RESELLER_ROLE ||
				selectedParentId === IS_RESELLER_ROLE)
		) {
			setLoadingDistBu(true);

			try {
				const searchTerms = {
					businessUnits: unitId ? unitId : null,
					type: typeFilterEnabled ? 1 : null,
				};

				const data = await fetchDistributersData(token, dispatch, navigate, 1, 10, 0, searchTerms);

				setFilteredDistributers(data.data || []);
			} catch (error) {
				console.error("Failed to fetch distributors:", error);
			} finally {
				setLoadingDistBu(false);
			}
		}
	};

	const handleClientsChange = (id, name, value) => {
		setClientId(name);

		if (name) {
			setClientId(name);
			setSelectedClientName(value);
			setVesselName([]);
			setVesselAccess(false);
			fetchVesselsByClients(name);
			setFilteredVessels([]);
			setSearchTerm(null);
			setPageClient(1);

			setPageVessel(1);
		} else {
			setClientAccess(false);
			handleClearInput("vesselName");
			handleClearInput("clientName");
			setVesselAccess(false);
			setClientAccess(false);
			setVesselName([]);
			handleClearInput("clientAccesss");
			setFilteredVessels([]);
			setPageClient(1);
			setSearchTermClient("");
		}

		setErrors((prevErrors) => ({
			...prevErrors,
			clientId: "",
		}));
	};

	const fetchClientsForBu = async (unitId, sig) => {
		if (token && (selectedRoleId === IS_CUSTOMER_ROLE || selectedParentId === IS_CUSTOMER_ROLE)) {
			setLoadingClientsBu(true);
			setFilteredClients([]);
			setLoaderClient(true);

			try {
				const data = await fetchClients(
					token,
					dispatch,
					navigate,
					pageClient,
					10,
					{
						filter: searchTermClient || null,
						businessUnits: unitId || [],
						selected: id,
					},
					1,
					sig,
				); // No pagination

				const totalPage = Math.ceil(data.totalItems / data.perPage);

				const updatedOptions = pageClient === 1 ? data.data : [...filteredClients, ...data.data];

				setFilteredClients(updatedOptions || []);

				setHasMoreClient(totalPage > pageClient);
			} catch (error) {
				console.error("Failed to fetch client:", error);
			} finally {
				setLoadingClientsBu(false);
				setLoaderClient(false);
			}
		}
	};
	const handleSearchSelectChangeClient = useCallback(
		(id, value) => {
			if (value) {
				setSearchTermClient(value);
				setPageClient(1);
			} else {
				setSearchTermClient("");
				setPageClient(1);
			}
		},
		[searchTermClient],
	);

	useEffect(() => {
		if (selectedUnitId && (searchTermClient || pageClient !== 1)) {
			fetchClientsForBu(selectedUnitId, controller.signal);
		}

		if (distributerId && (searchTermClient || pageClient !== 1)) {
			fetchClientsForDistributor(distributerId, controller.signal);
		}
		return () => {
			controller.abort();
		};
	}, [pageClient, searchTermClient]);

	useEffect(() => {
		if (selectedUnitId && searchTermClient === "") {
			fetchClientsForBu(selectedUnitId, controller.signal);
		}

		if (distributerId && searchTermClient === "") {
			fetchClientsForDistributor(distributerId, controller.signal);
		}

		return () => {
			controller.abort();
		};
	}, [searchTermClient]);

	const handleSearchSelectChangeVessel = useCallback(
		(id, value) => {
			if (value) {
				setVesselAccess(true);
				setSearchTerm(value);
				setPageVessel(1);
			} else {
				setVesselAccess(true);
				setSearchTerm("");
			}
		},
		[searchTerm],
	);

	const handleVesselAccessChange = (e) => {
		setVesselAccess(e.target.checked);
		//setSearchTerm("");

		// Only set vessel names if there are related vessel

		if (!e.target.checked) {
			setVesselName("");
		}
	};

	const handleVesselChange = (id, newSelectedIds) => {
		setVesselName(newSelectedIds);

		const stillSelected = selectedVessels.filter((vessel) => newSelectedIds.includes(vessel.id));

		const newSelectedFromOptions = filteredVessels.filter(
			(vessel) =>
				newSelectedIds.includes(vessel.id) && !stillSelected.some((v) => v.id === vessel.id),
		);

		const updatedSelected = [...stillSelected, ...newSelectedFromOptions];

		setSelectedVessels(updatedSelected);

		setErrors((prevErrors) => ({
			...prevErrors,
			vesselName: "",
		}));
	};

	const handleClientChangeMultiple = (id, newSelectedIds) => {
		setClientId(newSelectedIds);

		const stillSelected = selectedClients.filter((client) => newSelectedIds.includes(client.id));

		const newSelectedFromOptions = filteredClients.filter(
			(client) =>
				newSelectedIds.includes(client.id) && !stillSelected.some((c) => c.id === client.id),
		);

		const updatedSelected = [...stillSelected, ...newSelectedFromOptions];

		setSelectedClients(updatedSelected);

		setErrors((prevErrors) => ({
			...prevErrors,
			clientId: "",
		}));
	};
	const handleClientAccessChange = (e) => {
		setClientAccess(e.target.checked);

		if (!e.target.checked) {
			setClientId("");
		}
	};

	const handleClientAccessDistChange = (e) => {
		setClientAccess(e.target.checked);

		if (!e.target.checked) {
			setClientId("");
			setVesselName("");
			handleClearInput("vesselName");
			handleClearInput("vesselAccess");
		}
	};

	const handleDistributersChange = (id, selectedId, selectedName) => {
		if (selectedId) {
			setDistributerId(selectedId);
			setDistributerName(selectedName);
			// Reset client state
			setPageClient(1);
			setClientsByDistribuer([]);
			setHasMoreClient(true);
			if (
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE
			) {
				fetchClientsForDistributor(selectedId, controller.signal, 1);
			}

			fetchResellersForDist(selectedId);

			setClientAccess(false);
			setClientId("");
			setResellerId("");
		} else {
			setDistributerId("");
			setDistributerName("");

			// Reset client state
			setPageClient(1);
			setClientsByDistribuer([]);
			setHasMoreClient(true);

			setClientAccess(false);
			setClientId("");
			setResellerId("");
		}

		setErrors((prevErrors) => ({
			...prevErrors,
			distributerId: "",
		}));
	};

	const fetchClientsForDistributor = async (
		distId,
		sig,
		page = pageClient,
		searchTerm = searchTermClient,
	) => {
		if (
			token &&
			(selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedParentId === IS_DISTRIBUTOR_ROLE)
		) {
			setLoadingClientDist(true);
			setLoaderClient(true);

			try {
				const data = await fetchClients(
					token,
					dispatch,
					navigate,
					page,
					10,
					{
						filter: searchTerm,
						distributor_id: distId,
						selected: id,
					},
					1,
					sig,
				);

				const totalPage = Math.ceil(data.totalItems / data.perPage);

				setClientsByDistribuer((prev) =>
					page === 1
						? data.data
						: Array.from(new Map([...prev, ...data.data].map((item) => [item.id, item])).values()),
				);
				setHasMoreClient(totalPage > page);
			} catch (error) {
				console.error("Failed to fetch client:", error);
			} finally {
				setLoadingClientDist(false);
				setLoaderClient(false);
			}
		}
	};

	const handleResellersChange = (id, selectedId) => {
		if (selectedId) {
			setResellerId(selectedId);

			if (
				selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE
			) {
				fetchClientsForReseller(selectedId, controller.signal);
				setClientAccess(false);
				setClientId("");
			}
		} else {
			setResellerId("");
		}

		setErrors((prevErrors) => ({
			...prevErrors,
			resellerId: "",
		}));
		return () => {
			controller.abort();
		};
	};

	const fetchResellersForDist = async (distributorId) => {
		// Use GrowthBook feature flags for avoid fetching reseller api
		if (!resellerFetchEnabled) return null;

		if (token && (selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE)) {
			setLoadingResellerDist(true);

			const searchTerms = { distributor: distributorId };

			try {
				const data = await fetchResellersData(
					token,
					dispatch,
					navigate,
					1,
					10,
					0,
					searchTerms,
					false,
				);

				setFilteredResellers(data.data || []);
			} catch (error) {
				console.error("Failed to fetch resellers:", error);
				setFilteredResellers([]);
			} finally {
				setLoadingResellerDist(false);
			}
		}
	};

	const fetchClientsForReseller = async (resId, sig) => {
		if (
			token &&
			(selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE)
		) {
			setLoadingClientsReseller(true);
			setFilteredClientsReseller([]);
			setLoaderClient(true);

			try {
				const data = await fetchClients(
					token,
					dispatch,
					navigate,
					pageClient,
					10,
					{
						filter: searchTermClient,
						reseller: resId,
						selected: id,
					},
					1,
					sig,
				);

				const totalPage = Math.ceil(data.totalItems / data.perPage);

				const updatedOptions =
					pageClient === 1 ? data.data : [...filteredClientsReseller, ...data.data];

				setFilteredClientsReseller(updatedOptions || []);
				setHasMoreClient(totalPage > pageClient);
			} catch (error) {
				console.error("Failed to fetch client:", error);
			} finally {
				setLoadingClientsReseller(false);
				setLoaderClient(false);
			}
		}
	};

	const fetchVesselsByClients = async (clientId) => {
		const isAllowedRole =
			token &&
			(selectedRoleId === IS_CUSTOMER_ROLE ||
				selectedParentId === IS_CUSTOMER_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE);

		if (!isAllowedRole) return;

		setLoader(true);

		const requestId = ++currentRequestId.current;

		try {
			const data = await fetchVessels(
				token,
				dispatch,
				navigate,
				pageVessel,
				10,
				1, // paginate = true
				{ client: clientId, selected: id, siteName: searchTerm },
				"", // column
				"", // orderType
				null,
			);

			if (requestId !== currentRequestId.current) return;

			const totalPage = Math.ceil(data.totalItems / data.perPage);

			const updatedOptions = pageVessel === 1 ? data.data : [...filteredVessels, ...data.data];

			setFilteredVessels(updatedOptions);
			setHasMore(totalPage > pageVessel);
		} catch (error) {
			if (requestId === currentRequestId.current) {
				console.error("Failed to fetch vessels:", error);
			}
		} finally {
			if (requestId === currentRequestId.current) {
				setLoader(false);
			}
		}
	};

	useEffect(() => {
		if (clientId) {
			fetchVesselsByClients(clientId);
		}
	}, [pageVessel, searchTerm]);

	const handleRoleChange = (roleId, roleName) => {
		const selectedRole = rolesList?.data.find((role) => role.id === roleId);

		const parentId = selectedRole?.parent_id;
		setSelectedRoleId(roleId);
		setSelectedRoleName(roleName);
		setSelectedParentId(parentId);

		handleClearInput("unitName");
		handleClearInput("uploadedFile");
		handleClearInput("clientId");
		handleClearInput("vesselName");
		handleClearInput("filteredClients");
		handleClearInput("distributerId");
		handleClearInput("distributerName");
		handleClearInput("vesselAccess");
		handleClearInput("clientAccess");
		handleClearInput("resellerId");
		setPageClient(1);
		setHasMoreClient(true);
		setErrors((prevErrors) => ({
			...prevErrors,
			roleName: "",
		}));
	};

	const handleEnableUserChange = (e) => {
		setUserNotification(e.target.checked);
	};

	const handleEnableActivationChange = (e) => {
		setEnableActivation(e.target.checked);
	};

	const capitalizeFirstLetter = (string) => {
		if (!string) return "";
		return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	};

	const handleRedirectionUser = () => {
		navigate("/account_management/users");
	};

	const validateName = (name) => {
		if (!name || name.trim().length === 0) {
			return "This field is required.";
		}

		const trimmed = name.trim();

		if (trimmed.length < 2) {
			return "Must be at least 2 characters.";
		}

		// Supports international letters + spaces + apostrophes + hyphens
		const nameRegex = /^[\p{L}\s'-]+$/u;

		if (!nameRegex.test(trimmed)) {
			return "Only letters, spaces, apostrophes, and hyphens are allowed.";
		}

		return null;
	};

	const validateEmail = (email) => {
		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailPattern.test(email);
	};

	const validatePassword = (password) => {
		if (password.length < 8) {
			return "Password must be at least 8 characters long.";
		}
		if (!/[A-Z]/.test(password)) {
			return "Password must contain at least one uppercase letter.";
		}
		if (!/[a-z]/.test(password)) {
			return "Password must contain at least one lowercase letter.";
		}
		if (!/[0-9]/.test(password)) {
			return "Password must contain at least one number.";
		}
		if (!/[!@#$%^&*]/.test(password)) {
			return "Password must contain at least one special character.";
		}
		return "";
	};

	const validateForm = () => {
		const newErrors = {};
		let isValid = true;

		if (!statusId) {
			newErrors.statusId = "Status is required.";
			isValid = false;
		}

		if (validateName(firstName)) {
			newErrors.firstName = validateName(firstName);
			isValid = false;
		}

		if (validateName(lastName)) {
			newErrors.lastName = validateName(lastName);
			isValid = false;
		}

		if (!email) {
			newErrors.email = "Email is required.";
			isValid = false;
		} else if (!validateEmail(email)) {
			newErrors.email = "Please enter a valid Email address.";
			isValid = false;
		}
		if (!id) {
			if (!password) {
				newErrors.password = "Password is required.";
				isValid = false;
			} else {
				const passwordError = validatePassword(password);
				if (passwordError) {
					newErrors.password = passwordError;
					isValid = false;
				}
			}
		}

		if (
			!selectedUnitId &&
			selectedRoleId !== IS_ADMIN_ROLE &&
			selectedParentId !== IS_ADMIN_ROLE &&
			selectedRoleId !== IS_ACTIVATION_ROLE &&
			selectedParentId !== IS_ACTIVATION_ROLE
		) {
			newErrors.selectedUnitId = "Business Unit is required.";
			isValid = false;
		}
		if (
			(selectedRoleId === IS_CUSTOMER_ROLE ||
				(selectedParentId === IS_CUSTOMER_ROLE && selectedRoleId !== IS_TECHNICAL_PARTNER_ROLE)) &&
			!clientId &&
			selectedRoleId !== IS_ADMIN_ROLE &&
			selectedParentId !== IS_ADMIN_ROLE &&
			selectedRoleId !== IS_ACTIVATION_ROLE &&
			selectedParentId !== IS_ACTIVATION_ROLE
		) {
			newErrors.clientId = "Client is required.";
			isValid = false;
		}

		if (
			selectedRoleId === IS_TECHNICAL_PARTNER_ROLE &&
			selectedParentId === IS_CUSTOMER_ROLE &&
			!clientId &&
			selectedRoleId !== IS_ADMIN_ROLE &&
			selectedParentId !== IS_ADMIN_ROLE &&
			selectedRoleId !== IS_ACTIVATION_ROLE &&
			selectedParentId !== IS_ACTIVATION_ROLE
		) {
			newErrors.clientId = "Please select at least one client.";
			isValid = false;
		}

		if (!selectedRoleId) {
			newErrors.selectedRoleId = "Role is required.";
			isValid = false;
		}

		if (distributorFieldValidationEnabled) {
			if (
				selectedRoleId !== IS_ADMIN_ROLE &&
				selectedParentId !== IS_ADMIN_ROLE &&
				selectedRoleId !== IS_ACTIVATION_ROLE &&
				selectedParentId !== IS_ACTIVATION_ROLE
			) {
				if (
					selectedRoleId === IS_DISTRIBUTOR_ROLE ||
					selectedParentId === IS_DISTRIBUTOR_ROLE ||
					selectedRoleId === IS_RESELLER_ROLE ||
					selectedParentId === IS_RESELLER_ROLE
				) {
					if (!distributerId && filteredDistributers.length > 0) {
						newErrors.distributerId = "Distributer is required.";
						isValid = false;
					}
					if (
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE ||
						selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE ||
						selectedRoleId === IS_RESELLER_CUSTOMER_ROLE
					) {
						if ((vesselAccess && !vesselName) || (vesselAccess && vesselName.length === 0)) {
							newErrors.vesselName = "Please select at least one vessel.";
							isValid = false;
						}
					}
				}
			}
		}

		if (distributorFieldVisible) {
			if (
				(!distributorFieldValidationEnabled && selectedRoleId === IS_RESELLER_ROLE) ||
				selectedParentId === IS_RESELLER_ROLE
			) {
				if (!distributerId && filteredDistributers.length > 0) {
					newErrors.distributerId = "Distributer is required.";
					isValid = false;
				}
			}
		}

		if (
			!distributorFieldValidationEnabled &&
			(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_ROLE)
		) {
			if (!distributerId && !filteredDistributers.length > 0 && !isDistributor) {
				newErrors.distributerId = "Distributer is required.";
				isValid = false;
			}
			if ((vesselAccess && !vesselName) || (vesselAccess && vesselName.length === 0)) {
				newErrors.vesselName = "Please select at least one vessel.";
				isValid = false;
			}
		}
		if (
			(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) &&
			!clientId
		) {
			newErrors.clientId = "Please select a client.";
			isValid = false;
		}
		if (
			(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) &&
			distributerId &&
			!clientId
		) {
			newErrors.clientId = "Please select a client.";
			isValid = false;
		}
		if (
			(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
				selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) &&
			distributerId &&
			!clientId &&
			clientsByDistribuer.length === 0
		) {
			newErrors.distributerId = "No clients are available. Please select a different distributor!";

			isValid = false;
		}

		if (resellerFetchEnabled) {
			if (
				!resellerId &&
				(selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE)
			) {
				newErrors.resellerId = "Reseller is required.";
				isValid = false;
			}
		}

		if (resellerFetchEnabled) {
			if (
				selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE ||
				selectedRoleId === IS_RESELLER_CUSTOMER_ROLE
			) {
				if (!clientId) {
					newErrors.clientId = "Please select a client.";
					isValid = false;
				}

				if (vesselAccess && (!vesselName || vesselName.length === 0)) {
					newErrors.vesselName = "Please select at least one vessel.";
					isValid = false;
				}
			}
		}

		if (selectedRoleId === IS_CUSTOMER_ROLE || selectedParentId === IS_CUSTOMER_ROLE) {
			if (selectedUnitId && !clientId && filteredClients.length === 0) {
				newErrors.selectedUnitId = `No clients are available. Please select a different business unit!`;
				isValid = false;
			}

			if ((vesselAccess && !vesselName) || (vesselAccess && vesselName.length === 0)) {
				newErrors.vesselName = "Please select at least one vessel.";
				isValid = false;
			}
		}

		if (
			distributorFieldValidationEnabled &&
			(selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE) &&
			selectedUnitId &&
			!distributerId &&
			filteredDistributers.length === 0
		) {
			newErrors.selectedUnitId = `No distributors are available. Please select a different business unit!`;
			isValid = false;
		}

		if (resellerFetchEnabled) {
			if (
				(selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE) &&
				distributerId &&
				!resellerId &&
				filteredResellers.length === 0
			) {
				newErrors.distributerId = `No resellers are available. Please select a different distributor!`;
				isValid = false;
			}
		}

		if (
			(selectedRoleId === IS_DISTRIBUTOR_ROLE || selectedParentId === IS_DISTRIBUTOR_ROLE) &&
			selectedUnitId &&
			!distributerId &&
			filteredDistributers.length === 0
		) {
			newErrors.selectedUnitId = `No distributors are available. Please select a different business unit!`;
			isValid = false;
		}

		setErrors(newErrors);
		return isValid;
	};

	const handleAddSubmit = async (e) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		setIsSubmitting(true); // Disable the button and show Loading

		const userData = {
			first_name: firstName,
			last_name: lastName,
			email: email,
			password: password,
			state: statusId,
			enable_notification: userNotification,
			enable_activation: enableActivation ? 1 : 0,
			role: selectedRoleName,
			// business_units: selectedUnitId,
		};
		// Include business_units if role is not 2 or 3
		if (
			selectedRoleId !== IS_ADMIN_ROLE &&
			selectedParentId !== IS_ADMIN_ROLE &&
			selectedRoleId !== IS_ACTIVATION_ROLE &&
			selectedParentId !== IS_ACTIVATION_ROLE
		) {
			if (
				selectedRoleId === IS_CUSTOMER_ROLE ||
				(selectedParentId === IS_CUSTOMER_ROLE && selectedRoleId !== IS_TECHNICAL_PARTNER_ROLE)
			) {
				if (isCustomer) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const clientObject = filteredClients?.find((client) => client?.id === clientId);
					const businessUnitId = clientObject?.business_unit?.id;

					userData.business_units = selectedUnitId;
				}
				userData.clients = [clientId];
			} else if (
				selectedParentId === IS_CUSTOMER_ROLE &&
				selectedRoleId === IS_TECHNICAL_PARTNER_ROLE &&
				filteredClients.length > 0
			) {
				if (isCustomer) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const clientObject = filteredClients?.find((client) => client?.id === clientId);
					const businessUnitId = clientObject?.business_unit?.id;

					userData.business_units = selectedUnitId;
				}
				userData.clients = clientId;
			} else if (
				selectedRoleId === IS_DISTRIBUTOR_ROLE ||
				selectedParentId === IS_DISTRIBUTOR_ROLE
			) {
				if (
					clientsByDistribuer.length > 0 &&
					clientId &&
					(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE)
				) {
					// userData.company_id = distributerId;

					userData.clients = [clientId]; // Send clientId if it's an array
				}
				if (isDistributor) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const distObject = filteredDistributers?.find((dist) => dist?.id === distributerId);

					const businessUnitId = distObject?.business_units[0]?.id;

					userData.business_units = selectedUnitId;
				}

				if (!companyIdInPayloadEnabled) {
					if (
						selectedRoleId !== IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE &&
						selectedRoleId !== IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE
					) {
						userData.company_id = distributerId;
					}
				} else {
					userData.company_id = distributerId;
				}
			} else if (
				(selectedRoleId === IS_SALES_ROLE || selectedParentId === IS_SALES_ROLE) &&
				filteredClients.length > 0 &&
				clientAccess
			) {
				const foundClient = filteredClients.filter((client) => clientId.includes(client.id));
				const businessUnitIds = foundClient.map((client) => client.business_unit.id);
				const uniqueBusinessUnitIds = [...new Set(businessUnitIds)];

				userData.business_units = uniqueBusinessUnitIds;
				userData.clients = clientId;
			} else if (selectedRoleId === IS_SALES_ROLE || selectedParentId === IS_SALES_ROLE) {
				userData.business_units = selectedUnitId;
			} else if (selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE) {
				if (isDistributor) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const distObject = filteredDistributers?.find((dist) => dist?.id === distributerId);

					const businessUnitId = distObject?.business_units[0]?.id;

					userData.business_units = [businessUnitId];
				}

				if (resellerCompanyIdInPayloadEnabled) {
					userData.company_id = distributerId;
				}
				userData.reseller_id = resellerId;

				// ***Reseler role

				if (
					selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
					selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE
				) {
					if (filteredClientsReseller.length > 0) {
						userData.clients = [clientId];
					}
					if (vesselAccess && vesselName.length > 0) {
						userData.vessels = vesselName;
					}
				}
				/***************************************** */
			} else {
				userData.business_units = selectedUnitId;
			}

			if (vesselAccess && vesselName.length > 0) {
				userData.vessels = vesselName;
			}
		}
		try {
			const createdUser = await createUser(userData, token);

			if (createdUser && createdUser.errors) {
				const errorMessages = [];

				Object.keys(createdUser.errors).forEach((errorKey) => {
					createdUser.errors[errorKey].forEach((errorMessage) => {
						errorMessages.push(`${errorKey}: ${errorMessage}`);
					});
				});

				if (errorMessages.length > 0) {
					setErrorMessage(errorMessages.join("\n"));
					setShowErrorModal(true);
				}
			} else if (createdUser) {
				// Successful user creation
				dispatch(setAddUser(createdUser));
				setShowSuccessModal(true);

				setTimeout(() => handleRedirectionUser(), 1000);
			} else {
				setErrorMessage(`Failed to create the User ${firstName} ${lastName}`);

				setShowErrorModal(true);
			}
		} catch (error) {
			console.error("Error during user creation:", error);
			setErrorMessage(`Error during user creation`);
			setShowErrorModal(true);
		} finally {
			dispatch(setLoadingUsers(false));
			setIsSubmitting(false);
		}
	};

	const handleEditSubmit = async (e) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		setIsSubmitting(true);

		const userData = {
			first_name: firstName,
			last_name: lastName,
			email: email,
			state: statusId,
			enable_notification: userNotification,
			enable_activation: enableActivation ? 1 : 0,

			role: selectedRoleName,
			// business_units: selectedUnitId,
		};

		// Include business_units if role is not 2 or 3
		if (
			selectedRoleId !== IS_ADMIN_ROLE &&
			selectedParentId !== IS_ADMIN_ROLE &&
			selectedRoleId !== IS_ACTIVATION_ROLE &&
			selectedParentId !== IS_ACTIVATION_ROLE
		) {
			if (
				selectedRoleId === IS_CUSTOMER_ROLE ||
				(selectedParentId === IS_CUSTOMER_ROLE && selectedRoleId !== IS_TECHNICAL_PARTNER_ROLE)
			) {
				if (isCustomer) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const clientObject = filteredClients?.find((client) => client?.id === clientId);
					const businessUnitId = clientObject?.business_unit?.id;

					userData.business_units = selectedUnitId;
				}
				userData.clients = [clientId];
			} else if (
				selectedParentId === IS_CUSTOMER_ROLE &&
				selectedRoleId === IS_TECHNICAL_PARTNER_ROLE &&
				filteredClients.length > 0
			) {
				if (isCustomer) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const clientObject = filteredClients?.find((client) => client?.id === clientId);
					const businessUnitId = clientObject?.business_unit?.id;

					userData.business_units = selectedUnitId;
				}
				userData.clients = clientId;
			} else if (
				selectedRoleId === IS_DISTRIBUTOR_ROLE ||
				selectedParentId === IS_DISTRIBUTOR_ROLE
			) {
				if (
					clientsByDistribuer.length > 0 &&
					clientId &&
					(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE)
				) {
					// userData.company_id = distributerId;

					userData.clients = [clientId]; // Send clientId if it's an array
				}
				if (isDistributor) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const distObject = filteredDistributers?.find((dist) => dist?.id === distributerId);

					const businessUnitId = distObject?.business_units[0]?.id;

					userData.business_units = selectedUnitId;
				}

				if (!companyIdInPayloadEnabled) {
					if (
						selectedRoleId !== IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE &&
						selectedRoleId !== IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE
					) {
						userData.company_id = distributerId;
					}
				} else {
					userData.company_id = distributerId;
				}

				if (
					clientsByDistribuer.length > 0 &&
					clientId.length > 0 &&
					(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
						selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE)
				) {
					// userData.company_id = distributerId;

					userData.clients = clientId; // Send clientId if it's an array
				}
			} else if (
				(selectedRoleId === IS_SALES_ROLE || selectedParentId === IS_SALES_ROLE) &&
				filteredClients.length > 0 &&
				clientAccess
			) {
				const foundClient = filteredClients.filter((client) => clientId.includes(client.id));
				const businessUnitIds = foundClient.map((client) => client.business_unit.id);
				const uniqueBusinessUnitIds = [...new Set(businessUnitIds)];

				userData.business_units = uniqueBusinessUnitIds;
				userData.clients = clientId;
			} else if (selectedRoleId === IS_SALES_ROLE || selectedParentId === IS_SALES_ROLE) {
				userData.business_units = selectedUnitId;
			} else if (selectedRoleId === IS_RESELLER_ROLE || selectedParentId === IS_RESELLER_ROLE) {
				if (isDistributor) {
					userData.business_units = [allBusinessList[0].id];
				} else {
					const distObject = filteredDistributers?.find((dist) => dist?.id === distributerId);

					const businessUnitId = distObject?.business_units[0]?.id;

					userData.business_units = [businessUnitId];
				}

				if (resellerCompanyIdInPayloadEnabled) {
					userData.company_id = distributerId;
				}

				userData.reseller_id = resellerId;

				// ***Reseler role

				if (
					selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
					selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE
				) {
					if (filteredClientsReseller.length > 0) {
						userData.clients = [clientId];

						if (vesselAccess && vesselName.length > 0) {
							userData.vessels = vesselName;
						}
					}
				}
				/***************************************** */
			} else {
				userData.business_units = selectedUnitId;
			}

			// Include vessels if vesselAccess is enabled
			if (vesselAccess && vesselName.length > 0) {
				userData.vessels = vesselName;
			}
		}

		try {
			const editUser = await updateUser(id, userData, token);

			if (editUser && editUser.errors) {
				const errorMessages = [];

				Object.keys(editUser.errors).forEach((errorKey) => {
					editUser.errors[errorKey].forEach((errorMessage) => {
						errorMessages.push(`${errorKey}: ${errorMessage}`);
					});
				});

				if (errorMessages.length > 0) {
					setErrorMessage(errorMessages.join("\n"));
					setShowErrorModal(true);
				}
			} else if (editUser) {
				// Successful user creation
				dispatch(setAddUser(editUser));
				setShowSuccessModal(true);

				setTimeout(() => handleRedirectionUser(), 1000);
			} else {
				setErrorMessage(`Failed to edit the User ${firstName} ${lastName}`);

				setShowErrorModal(true);
			}
		} catch (error) {
			console.error("Error during user modification:", error);
			setErrorMessage(`Error during user modification`);
			setShowErrorModal(true);
		} finally {
			dispatch(setLoadingUsers(false));
			setIsSubmitting(false);
		}
	};

	const handleResendEmail = async (e) => {
		e.preventDefault();

		setIsSubmitting(true);

		try {
			const resendEmail = await resendRegisterEmail(id, token);

			if (resendEmail && resendEmail.errors) {
				// Handle errors first
				const errorMessages = [];

				if (resendEmail.errors.email) {
					errorMessages.push(...resendEmail.errors.email);
				}

				if (errorMessages.length > 0) {
					setErrorMessage(errorMessages.join("\n"));
					setShowErrorModal(true);
				}
			} else if (resendEmail) {
				// Success case
				setSuccessMessage("The email has been successfully sent.");
				setShowSuccessModal(true);
			}
		} catch (error) {
			console.error("Error during sending token:", error);
			setErrorMessage(`Error during email sending: ${error.message}`);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			{" "}
			<div className="px-0 pt-20 pb-4 sm:px-2 md:px-4 lg:px-4 xl:px-4 2xl:px-4">
				{loadingDetails ? (
					<div className="flex h-32 items-center justify-center sm:h-64">
						<div className="h-12 w-12 animate-spin rounded-full border-gray-700 border-t-2 border-b-2 sm:h-24 sm:w-24"></div>
					</div>
				) : (
					<>
						<div className="grid w-full gap-2 p-4">
							<div className="flex justify-start space-x-4 space-y-1 sm:space-x-6 lg:space-x-8">
								{/* <Button
            text="Users List"
            onClick={handleNavigateUsersList}
            className={"text-white hover:bg-button-hover bg-button-bg"}
            color=""
          /> */}

								<button
									type="button"
									onClick={handleNavigateUsersList}
									className="flex w-auto min-w-[40px] items-center rounded-lg bg-dark-blue bg-opacity-80 p-2 font-medium text-white text-xs hover:bg-opacity-40 focus:outline-none focus:ring-2 focus:ring-blue-gray"
								>
									<img src="/src/assets/icons/arrow-left.svg" alt="Back" className="h-5 w-5" />
								</button>
								<div className="grid gap-2 text-start">
									<span className={"font-semibold text-lg text-white lg:text-xl"}>
										{" "}
										{`User Details`}
									</span>
									<span className="font-extralight text-blue-gray text-xs sm:text-sm">
										Manage User Details and Role Access
									</span>
								</div>
							</div>
							{!isMobile && (
								<div className="mt-2 flex items-center justify-end sm:flex-row sm:space-x-6 sm:space-y-0 md:justify-end lg:space-x-2">
									{id ? (
										<>
											{canEditUsers && (
												<>
													{!lastLogin && !isloading && id && (
														<Button
															text={isSubmitting ? "Loading..." : "Send Registration Email"}
															disabled={isSubmitting}
															onClick={handleResendEmail}
															className={
																"w-full text-white hover:bg-blue-gray hover:bg-opacity-40 sm:w-auto"
															}
															icon={EmailIcon}
														/>
													)}

													<Button
														text={isSubmitting ? "Loading..." : "Update"}
														onClick={(e) => {
															handleEditSubmit(e);
														}}
														disabled={isSubmitting}
														className={
															"w-full text-white hover:bg-blue-gray hover:bg-opacity-40 sm:w-auto"
														}
														icon={FloppyDiskIcon}
													/>
												</>
											)}
										</>
									) : (
										<Button
											text={isSubmitting ? "Loading..." : "Save"}
											onClick={(e) => {
												handleAddSubmit(e);
											}}
											disabled={isSubmitting}
											className={
												"w-full text-white hover:bg-blue-gray hover:bg-opacity-40 sm:w-auto"
											}
											icon={FloppyDiskIcon}
										/>
									)}{" "}
								</div>
							)}
						</div>

						<div className="mt-4 grid grid-cols-1 gap-6 lg:grid-cols-2">
							{" "}
							{!isDistributor && !isCustomer && (
								<div className="w-full rounded-lg border border-gray-700 bg-navbar-bg p-6 text-start shadow">
									<form className="space-y-4">
										{!selectedRoleId && (
											<div className="w-full rounded-lg border border-blue-gray bg-navbar-bg p-4 text-start shadow">
												<span className="font-semibold text-normal text-yellow-500">
													Please select a role first:
												</span>
												<p className="text-gray-300">
													To avoid losing any entered data, make sure to select a role before
													filling out the other fields.
												</p>
											</div>
										)}
										{/* Status Field */}
										<SelectInput
											id="status"
											dataTestId="status-select"
											placeholder="Status"
											label="Status *"
											value={statusId}
											onChange={handleStatusChange}
											options={statusData}
											displayField="status"
											className={`m-0 block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
												errors.statusId ? "border-red-500" : ""
											}`}
											required
											marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
											classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
										/>
										{errors.statusId && (
											<p className="mt-1 text-red-500 text-sm">{errors.statusId}</p>
										)}

										{/* Last name Field */}

										<Input
											id="lastName"
											placeholder="Last name"
											label="Last name *"
											value={lastName}
											onChange={(value) => {
												setLastName(value);
												setErrors((prevErrors) => ({
													...prevErrors,
													lastName: validateName(value),
												}));
											}}
											onClear={() => handleClearInput("lastName")}
											className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
												errors.lastName ? "border-red-500" : ""
											}`}
											required
										/>
										{errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}

										{/* First name Field */}

										<Input
											id="firstName"
											placeholder="First name"
											label="First name *"
											value={firstName}
											onChange={(value) => {
												setFirstName(value);
												setErrors((prevErrors) => ({
													...prevErrors,
													firstName: validateName(value),
												}));
											}}
											onClear={() => handleClearInput("firstName")}
											className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
												errors.firstName ? "border-red-500" : ""
											}`}
											required
										/>
										{errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}

										{/* Email Field */}

										<Input
											id="email"
											placeholder="Email"
											label="Email *"
											type="email"
											value={email}
											onChange={(value) => {
												setEmail(value);
												setErrors((prevErrors) => ({
													...prevErrors,
													email: "",
												}));
											}}
											onClear={() => handleClearInput("email")}
											className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
												errors.email ? "border-red-500" : ""
											}`}
											required
										/>
										{errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}

										{/* Password Field */}
										{!id && (
											<>
												<Input
													id="password"
													label="Password *"
													placeholder="Password"
													value={password}
													onChange={(value) => {
														setPassword(value);
														setErrors((prevErrors) => ({
															...prevErrors,
															password: "",
														}));
													}}
													// isDisabled={true} // Conditionally disable the input
													onClear={() => handleClearInput("password")}
													className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
														errors.password ? "border-red-500" : ""
													}`}
													required
												/>
												{errors.password && (
													<p className="text-red-500 text-sm">{errors.password}</p>
												)}
											</>
										)}

										{/* Business Units Field */}

										{selectedRoleId !== IS_ADMIN_ROLE &&
											selectedParentId !== IS_ADMIN_ROLE &&
											selectedRoleId !== IS_ACTIVATION_ROLE &&
											selectedParentId !== IS_ACTIVATION_ROLE &&
											businessUnitVisible &&
											selectedRoleId !== null && (
												<>
													<SelectMultipleInputs
														id="unitName"
														placeholder="Select one or more business units"
														label="Business Units *"
														value={selectedUnitId}
														onChange={handleBusinessUnitChange}
														options={allBusinessList.map((business) => ({
															id: business.id,
															name: business.name,
														}))}
														displayField="name"
														className={`input-bg block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
															errors.selectedUnitId ? "border-red-500" : ""
														}`}
														required
														error={errors.selectedUnitId}
														marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
														classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
													/>
												</>
											)}

										{errors.selectedUnitId && (
											<p className="text-red-500 text-sm">{errors.selectedUnitId}</p>
										)}

										{/* condition clients and not role === customer | customer readonly*/}
										{selectedUnitId && (
											<>
												{(selectedRoleId === IS_CUSTOMER_ROLE ||
													(selectedParentId === IS_CUSTOMER_ROLE &&
														selectedRoleId !== IS_TECHNICAL_PARTNER_ROLE)) && (
													<>
														<SelectInputClient
															id="clientSelect"
															placeholder="Select a Client"
															label=" Clients *"
															value={clientId}
															onChange={handleClientsChange}
															options={filteredClients}
															search={handleSearchSelectChangeClient}
															fetchMoreData={() => {
																setPageClient((prev) => prev + 1);
															}}
															displayField="name"
															hasMore={hasMoreClient}
															loader={loaderClient}
															selectedItems={selectedClientName}
															marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
															classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
														/>
														{errors.clientId && (
															<p className="text-red-500 text-sm">{errors.clientId}</p>
														)}{" "}
													</>
												)}
												{selectedParentId === IS_CUSTOMER_ROLE &&
													selectedRoleId === IS_TECHNICAL_PARTNER_ROLE && (
														<>
															<SelectHasMoreMultipleInputs
																id="clientSelect"
																placeholder="Select one or more clients"
																label="Clients *"
																value={clientId}
																onChange={handleClientChangeMultiple}
																options={filteredClients}
																displayField="name"
																fetchMoreData={() => setPageClient((prev) => prev + 1)}
																hasMore={hasMoreClient}
																loader={loaderClient}
																selectedItems={selectedClients}
																search={handleSearchSelectChangeClient}
																marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
																classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
																attr="name"
															/>
															{errors.clientId && (
																<p className="text-red-500 text-sm">{errors.clientId}</p>
															)}
														</>
													)}
											</>
										)}

										{/* Client Access Field */}
										{/* {selectedUnitId &&
                      (selectedRoleId === IS_SALES_ROLE ||
                        selectedParentId === IS_SALES_ROLE) && (
                        <>
                          <div className="flex items-center">
                            <input
                              id="link-checkbox"
                              type="checkbox"
                              checked={clientAccess}
                              onChange={handleClientAccessChange}
                              className="w-4 h-4 text-blue-gray bg-blue-gray border-blue-gray rounded focus:ring-dark-blue ring-offset-dark-blue focus:ring-2"
                            />
                            <label
                              htmlFor="link-checkbox"
                              className="ms-2 text-gray-400"
                            >
                              Access by Clients
                            </label>
                          </div>

                          {clientAccess && (
                            <>
                              <SelectHasMoreMultipleInputs
                                id="clientSelect"
                                placeholder="Select one or more clients"
                                label="Clients Technical*"
                                value={clientId}
                                onChange={handleClientChangeMultiple}
                                options={filteredClients}
                                displayField="name"
                                fetchMoreData={() =>
                                  setPageClient((prev) => prev + 1)
                                }
                                hasMore={hasMoreClient}
                                loader={loaderClient}
                                selectedItems={selectedClients}
                                search={handleSearchSelectChangeClient}
                                marginTop="mt-4"
                                attr="name"
                              />
                              {errors.clientId && (
                                <p className="text-red-500 text-sm">
                                  {errors.clientId}
                                </p>
                              )}
                            </>
                          )}
                        </>
                      )} */}

										{/* Vessel Access Field */}
										{(selectedRoleId === IS_CUSTOMER_ROLE ||
											(selectedParentId === IS_CUSTOMER_ROLE &&
												selectedRoleId !== IS_TECHNICAL_PARTNER_ROLE)) && (
											<>
												{clientId && filteredClients.length > 0 && selectedUnitId && (
													<>
														<div className="flex items-center">
															<input
																id="link-checkbox-vess-access"
																type="checkbox"
																checked={vesselAccess}
																onChange={handleVesselAccessChange}
																className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
															/>
															<label
																htmlFor="link-checkbox-vess-access"
																className="ms-2 text-gray-400"
															>
																Enable Vessel Access
															</label>
														</div>

														{vesselAccess && (
															<>
																<SelectHasMoreMultipleInputs
																	id="siteName"
																	placeholder="Select one or more site name"
																	label="Site Name *"
																	value={vesselName}
																	onChange={handleVesselChange}
																	search={handleSearchSelectChangeVessel}
																	options={filteredVessels.map((vessel) => ({
																		id: vessel.id,
																		name: vessel.site_name,
																	}))}
																	displayField="name"
																	fetchMoreData={() => setPageVessel((prev) => prev + 1)}
																	hasMore={hasMore}
																	loader={loader}
																	selectedItems={selectedVessels}
																	marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
																	classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
																	attr="site_name"
																/>
																{errors.vesselName && (
																	<p className="text-red-500 text-sm">{errors.vesselName}</p>
																)}
															</>
														)}
													</>
												)}
											</>
										)}
										{/* Use GrowthBook feature flags to hide the dist field for adista */}

										{/* Distributer Field */}
										{(((selectedRoleId === IS_DISTRIBUTOR_ROLE ||
											selectedParentId === IS_DISTRIBUTOR_ROLE) &&
											businessUnitVisible) ||
											selectedRoleId === IS_RESELLER_ROLE ||
											selectedParentId === IS_RESELLER_ROLE) &&
											selectedUnitId &&
											distributorFieldVisible && (
												<>
													<SelectInput
														id="distributors"
														dataTestId="distributors-select"
														placeholder="Select a Distributor"
														label="Distributors *"
														value={distributerId}
														onChange={handleDistributersChange}
														options={filteredDistributers.map((dist) => ({
															id: dist.id,
															name: dist.name,
														}))}
														displayField="name"
														className={`block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
															errors.distributerId ? "border-red-500" : ""
														}`}
														required
														marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
														classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
													/>
													{errors.distributerId && (
														<p className="text-red-500 text-sm">{errors.distributerId}</p>
													)}
												</>
											)}
										{/* Client Access Field As Distributor */}
										{(selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_ADMIN_ROLE ||
											selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_OPERATOR_ROLE ||
											selectedRoleId === IS_DISTRIBUTOR_CUSTOMER_READONLY_ROLE) &&
											(adistaLayoutEnabled ||
												(selectedUnitId && distributerId && filteredDistributers)) && (
												<>
													<SelectInputClient
														id="clientSelect"
														placeholder="Select a Client"
														label="Clients *"
														value={clientId}
														onChange={handleClientsChange}
														options={clientsByDistribuer}
														displayField="name"
														search={handleSearchSelectChangeClient}
														fetchMoreData={() => setPageClient((prev) => prev + 1)}
														hasMore={hasMoreClient}
														loader={loaderClient}
														required
														selectedItems={selectedClientName}
														marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
														classDropdown={`${isMobile ? "relative" : "absolute z-50"}`}
													/>

													{errors.clientId && (
														<p className="text-red-500 text-sm">{errors.clientId}</p>
													)}

													{clientId && (
														<>
															<div className="flex items-center">
																<input
																	id="link-checkbox-vess-access"
																	type="checkbox"
																	checked={vesselAccess}
																	onChange={handleVesselAccessChange}
																	className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
																/>
																<label
																	htmlFor="link-checkbox-vess-access"
																	className="ms-2 text-gray-400"
																>
																	Enable Vessel Access
																</label>
															</div>

															{vesselAccess && (
																<>
																	<SelectHasMoreMultipleInputs
																		id="siteName"
																		placeholder="Select one or more site name"
																		label="Site Name *"
																		value={vesselName}
																		onChange={handleVesselChange}
																		options={filteredVessels.map((vessel) => ({
																			id: vessel.id,
																			name: vessel.site_name,
																		}))}
																		displayField="name"
																		fetchMoreData={() => setPageVessel((prev) => prev + 1)}
																		hasMore={hasMore}
																		loader={loader}
																		selectedItems={selectedVessels}
																		search={handleSearchSelectChangeVessel}
																		marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
																		classDropdown={`${isMobile ? "relative" : "absolute z-50"}`}
																		attr="site_name"
																	/>

																	{errors.vesselName && (
																		<p className="text-red-500 text-sm">{errors.vesselName}</p>
																	)}
																</>
															)}
														</>
													)}
												</>
											)}

										{/********************************************  Resellers Select input ***********************************************************/}

										{(selectedRoleId === IS_RESELLER_ROLE ||
											selectedParentId === IS_RESELLER_ROLE) &&
											resellerFetchEnabled &&
											distributerId && (
												<>
													<SelectInput
														id="resellers"
														dataTestId="resellers-select"
														placeholder="Select a Reseller"
														label="Reseller *"
														value={resellerId}
														onChange={handleResellersChange}
														options={filteredResellers.map((res) => ({
															id: res.id,
															name: res.name,
														}))}
														displayField="name"
														className={`block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
															errors.resellerId ? "border-red-500" : ""
														}`}
														required
														marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
														classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
													/>
													{errors.resellerId && (
														<p className="text-red-500 text-sm">{errors.resellerId}</p>
													)}

													{/********************* Is reseller client role ************************/}

													{/* Client Access Field */}
													{resellerId &&
														(selectedRoleId === IS_RESELLER_CUSTOMER_ROLE ||
															selectedRoleId === IS_RESELLER_CUSTOMER_READONLY_ROLE) && (
															<>
																<SelectInputClient
																	id="clientSelect"
																	placeholder="Select a Client"
																	label=" Clients *"
																	value={clientId}
																	onChange={handleClientsChange}
																	options={filteredClientsReseller}
																	displayField="name"
																	search={handleSearchSelectChangeClient}
																	fetchMoreData={() => {
																		setPageClient((prev) => prev + 1);
																	}}
																	hasMore={hasMoreClient}
																	loader={loaderClient}
																	required
																	selectedItems={selectedClientName}
																	className={`block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
																		errors.clientId ? "border-red-500" : ""
																	}`}
																	marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
																	classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
																/>
																{errors.clientId && (
																	<p className="text-red-500 text-sm">{errors.clientId}</p>
																)}
															</>
														)}

													{clientId && resellerId && (
														<>
															<div className="flex items-center">
																<input
																	id="link-checkbox-vessel-access"
																	type="checkbox"
																	checked={vesselAccess}
																	onChange={handleVesselAccessChange}
																	className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
																/>
																<label
																	htmlFor="link-checkbox-vessel-access"
																	className="ms-2 text-gray-400"
																>
																	Enable Vessel Access
																</label>
															</div>
															{vesselAccess && (
																<>
																	<SelectHasMoreMultipleInputs
																		id="siteName"
																		placeholder="Select one or more site name"
																		label="Site Name *"
																		value={vesselName}
																		onChange={handleVesselChange}
																		options={filteredVessels.map((vessel) => ({
																			id: vessel.id,
																			name: vessel.site_name,
																		}))}
																		displayField="name"
																		fetchMoreData={() => setPageVessel((prev) => prev + 1)}
																		hasMore={hasMore}
																		loader={loader}
																		selectedItems={selectedVessels}
																		search={handleSearchSelectChangeVessel}
																		marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
																		classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
																		attr="site_name"
																	/>
																	{errors.vesselName && (
																		<p className="text-red-500 text-sm">{errors.vesselName}</p>
																	)}
																</>
															)}
														</>
													)}
												</>
											)}

										{/* Enable Activation Field */}
										{(currentUserRole?.id === IS_ADMIN_ROLE ||
											currentUserRole?.id === IS_ACTIVATION_ROLE) && (
											<div className="flex items-center">
												<input
													id="link-checkbox-activation"
													type="checkbox"
													checked={enableActivation}
													onChange={handleEnableActivationChange}
													className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
												/>
												<label htmlFor="link-checkbox-activation" className="ms-2 text-gray-400">
													Enable Activation
												</label>
											</div>
										)}

										{/* User Notification Field */}
										<div className="flex items-center">
											<input
												id="link-checkbox-notification"
												type="checkbox"
												checked={userNotification}
												onChange={handleEnableUserChange}
												className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
											/>
											<label htmlFor="link-checkbox-notification" className="ms-2 text-gray-400">
												Enable User Notification
											</label>
										</div>
									</form>
								</div>
							)}
							{!adistaLayoutEnabled && (
								<>
									{isDistributor && (
										<FormForDistributor
											statusId={statusId}
											handleStatusChange={handleStatusChange}
											statusData={statusData}
											errors={errors}
											setErrors={setErrors}
											lastName={lastName}
											setLastName={setLastName}
											firstName={firstName}
											setFirstName={setFirstName}
											email={email}
											setEmail={setEmail}
											password={password}
											setPassword={setPassword}
											selectedRoleId={selectedRoleId}
											handleRoleChange={handleRoleChange}
											selectedRoleName={selectedRoleName}
											currentUserRole={currentUserRole}
											handleClientAccessDistChange={handleClientAccessDistChange}
											clientAccess={clientAccess}
											handleClientsChange={handleClientsChange}
											clientId={clientId}
											handleResellersChange={handleResellersChange}
											resellerId={resellerId}
											handleEnableUserChange={handleEnableUserChange}
											userNotification={userNotification}
											isDistributor={isDistributor}
											distributor={distributor}
											setDistributerName={setDistributerName}
											selectedParentId={selectedParentId}
											selectedUnitId={selectedUnitId}
											setSelectedUnitId={setSelectedUnitId}
											setName={setName}
											allBusinessList={allBusinessList}
											filteredResellers={filteredResellers}
											loadingResellerDist={loadingResellerDist}
											loading={loading}
											distributerId={distributerId}
											setDistributerId={setDistributerId}
											setClientId={setClientId}
											distributerName={distributerName}
											clientsByDistribuer={clientsByDistribuer}
											fetchClientsForDistributor={fetchClientsForDistributor}
											loadingClientDist={loadingClientDist}
											filteredDistributers={filteredDistributers}
											filteredVessels={filteredVessels}
											vesselName={vesselName}
											vesselAccess={vesselAccess}
											handleBusinessUnitChange={handleBusinessUnitChange}
											handleVesselChange={handleVesselChange}
											handleVesselAccessChange={handleVesselAccessChange}
											handleClientAccessChange={handleClientAccessChange}
											handleClearInput={handleClearInput}
											fetchResellersForDist={fetchResellersForDist}
											setClientAccess={setClientAccess}
											id={id}
											filteredClientsReseller={filteredClientsReseller}
											loadingClientsReseller={loadingClientsReseller}
											hasMore={hasMore}
											loader={loader}
											selectedVessels={selectedVessels}
											handleSearchSelectChange={handleSearchSelectChangeVessel}
											fetchMoreData={() => setPageVessel((prev) => prev + 1)}
											fetchClientsForReseller={fetchClientsForReseller}
											fetchVesselsByClients={fetchVesselsByClients}
											clients={clients}
											hasMoreClient={hasMoreClient}
											loaderClient={loaderClient}
											handleSearchSelectChangeClient={handleSearchSelectChangeClient}
											fetchMoreDataClient={() => setPageClient((prev) => prev + 1)}
											selectedClientName={selectedClientName}
											isMobile={isMobile}
										/>
									)}
									{isCustomer && (
										<FormForCustormer
											statusId={statusId}
											handleStatusChange={handleStatusChange}
											statusData={statusData}
											errors={errors}
											setErrors={setErrors}
											lastName={lastName}
											setLastName={setLastName}
											firstName={firstName}
											setFirstName={setFirstName}
											email={email}
											setEmail={setEmail}
											password={password}
											setPassword={setPassword}
											selectedRoleId={selectedRoleId}
											handleRoleChange={handleRoleChange}
											selectedRoleName={selectedRoleName}
											currentUserRole={currentUserRole}
											handleClientsChange={handleClientsChange}
											handleEnableUserChange={handleEnableUserChange}
											userNotification={userNotification}
											isCustomer={isCustomer}
											selectedParentId={selectedParentId}
											selectedUnitId={selectedUnitId}
											setSelectedUnitId={setSelectedUnitId}
											setName={setName}
											allBusinessList={allBusinessList}
											loading={loading}
											filteredClients={filteredClients}
											filteredVessels={filteredVessels}
											vesselName={vesselName}
											vesselAccess={vesselAccess}
											handleVesselChange={handleVesselChange}
											handleVesselAccessChange={handleVesselAccessChange}
											handleClearInput={handleClearInput}
											id={id}
											loadingClientsBu={loadingClientsBu}
											fetchClientsForBu={fetchClientsForBu}
											fetchVesselsByClients={fetchVesselsByClients}
											hasMore={hasMore}
											loader={loader}
											selectedVessels={selectedVessels}
											handleSearchSelectChange={handleSearchSelectChangeVessel}
											fetchMoreData={() => setPageVessel((prev) => prev + 1)}
											clients={clients}
											setClientId={setClientId}
											isMobile={isMobile}
										/>
									)}
								</>
							)}
							{/* Use GrowthBook feature flags for form distributor connected user (adista + terenova) */}
							{adistaLayoutEnabled && (
								<>
									{isDistributor && (
										<FormForAdistaT
											statusId={statusId}
											handleStatusChange={handleStatusChange}
											statusData={statusData}
											errors={errors}
											setErrors={setErrors}
											lastName={lastName}
											setLastName={setLastName}
											firstName={firstName}
											setFirstName={setFirstName}
											email={email}
											setEmail={setEmail}
											password={password}
											setPassword={setPassword}
											selectedRoleId={selectedRoleId}
											handleRoleChange={handleRoleChange}
											selectedRoleName={selectedRoleName}
											currentUserRole={currentUserRole}
											handleClientAccessDistChange={handleClientAccessDistChange}
											clientAccess={clientAccess}
											handleClientsChange={handleClientsChange}
											clientId={clientId}
											handleResellersChange={handleResellersChange}
											resellerId={resellerId}
											handleEnableUserChange={handleEnableUserChange}
											userNotification={userNotification}
											isDistributor={isDistributor}
											distributor={distributor}
											setDistributerName={setDistributerName}
											selectedParentId={selectedParentId}
											selectedUnitId={selectedUnitId}
											setSelectedUnitId={setSelectedUnitId}
											setName={setName}
											allBusinessList={allBusinessList}
											filteredResellers={filteredResellers}
											loadingResellerDist={loadingResellerDist}
											loading={loading}
											distributerId={distributerId}
											setDistributerId={setDistributerId}
											setClientId={setClientId}
											distributerName={distributerName}
											clientsByDistribuer={clientsByDistribuer}
											fetchClientsForDistributor={fetchClientsForDistributor}
											loadingClientDist={loadingClientDist}
											filteredDistributers={filteredDistributers}
											filteredVessels={filteredVessels}
											vesselName={vesselName}
											vesselAccess={vesselAccess}
											handleBusinessUnitChange={handleBusinessUnitChange}
											handleVesselChange={handleVesselChange}
											handleVesselAccessChange={handleVesselAccessChange}
											handleClientAccessChange={handleClientAccessChange}
											handleClearInput={handleClearInput}
											fetchResellersForDist={fetchResellersForDist}
											setClientAccess={setClientAccess}
											id={id}
											filteredClientsReseller={filteredClientsReseller}
											loadingClientsReseller={loadingClientsReseller}
											hasMore={hasMore}
											loader={loader}
											selectedVessels={selectedVessels}
											handleSearchSelectChange={handleSearchSelectChangeVessel}
											fetchMoreData={() => setPageVessel((prev) => prev + 1)}
											fetchClientsForReseller={fetchClientsForReseller}
											fetchVesselsByClients={fetchVesselsByClients}
											clients={clients}
											hasMoreClient={hasMoreClient}
											loaderClient={loaderClient}
											handleSearchSelectChangeClient={handleSearchSelectChangeClient}
											fetchMoreDataClient={() => setPageClient((prev) => prev + 1)}
											selectedClientName={selectedClientName}
											isMobile={isMobile}
											handleDistributersChange={handleDistributersChange}
											buName={business_units}
											enableActivation={enableActivation}
											handleEnableActivationChange={handleEnableActivationChange}
										/>
									)}
								</>
							)}
							<div className="w-full rounded-lg border border-gray-700 bg-navbar-bg p-6 text-start shadow">
								<div>
									<span className="font-semibold text-normal text-white">
										Role<span className="ml-1 text-gray-400">*</span>
									</span>
									{errors.selectedRoleId && (
										<p className="text-red-500 text-sm">{errors.selectedRoleId}</p>
									)}
									{loading ? (
										<div className="flex h-64 items-center justify-center">
											<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
										</div>
									) : (
										(rolesList?.data || []).map((role) => (
											<RoleListItem
												key={role.name}
												role={role}
												selectedRoleName={selectedRoleName}
												handleRoleChange={handleRoleChange}
												currentUserRole={currentUserRole}
												capitalizeFirstLetter={() => capitalizeFirstLetter(role?.name)}
												errors={errors}
											/>
										))
									)}
								</div>
							</div>
							{/* Additional role-related fields can go here */}
							{isMobile && (
								<div className="fixed bottom-0 left-0 z-10 z-5 mt-16 w-full bg-black p-4 px-4 py-4 pt-2 sm:static sm:border-none sm:p-0">
									<div className="flex items-center justify-center sm:flex-row sm:space-x-6 sm:space-y-0 lg:space-x-2">
										{id ? (
											<>
												{canEditUsers && (
													<>
														{!lastLogin && !isloading && id && (
															<Button
																text={isSubmitting ? "Loading..." : "Send Registration Email"}
																disabled={isSubmitting}
																onClick={handleResendEmail}
																className="!bg-button-bg w-full !hover:bg-blue-gray text-center text-white hover:bg-opacity-40"
																icon={EmailIcon}
															/>
														)}

														<Button
															text={isSubmitting ? "Loading..." : "Update"}
															onClick={(e) => {
																handleEditSubmit(e);
															}}
															disabled={isSubmitting}
															className="!bg-button-bg !hover:bg-blue-gray text-center text-white hover:bg-opacity-40"
															icon={FloppyDiskIcon}
														/>
													</>
												)}
											</>
										) : (
											<Button
												text={isSubmitting ? "Loading..." : "Save"}
												onClick={(e) => {
													handleAddSubmit(e);
												}}
												disabled={isSubmitting}
												className="w-full bg-button-bg text-white hover:bg-blue-gray hover:bg-opacity-40 sm:w-auto"
												icon={FloppyDiskIcon}
											/>
										)}
									</div>
								</div>
							)}
						</div>
					</>
				)}
				<ModalAlert
					isOpen={showErrorModal}
					type="error"
					closeModal={() => setShowErrorModal(false)}
					message={errorMessage}
				/>

				<ModalAlert
					isOpen={showSuccessModal}
					type="success"
					closeModal={() => setShowSuccessModal(false)}
					message={successMessage}
				/>
			</div>
		</>
	);
};

export default FormUsers;
